import { createEventBus } from "@core/features/eventBus";
import { VideoEvents } from "./video.events";

export const videoEventBus = createEventBus<VideoEvents>();
